// extracted by mini-css-extract-plugin
export var carrierIcon = "_to-0";
export var carrierLogo = "_to-1";
export var detailsSection = "_to-2";